let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lO3FM")).then(() => parcelRequire('lu6uO'));